export const ADMIN_ROLE = "Admin";
export const SUPER_ADMIN_ROLE = "SuperAdmin";
export const USER_STORAGE_ITEM = "jobapp-admin::user";